import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import {analysisFields} from "./client/Client";
import {dateToDE, orderByName} from "./util/Util";



const Stats = ({
	trainers,
	licenses,
}) => {
	// only include enabled trainers
	trainers = trainers.filter(t => t.enabled);

	// trainers
	const trainerTable = (
		<Table>
			<thead>
				<tr>
					{trainerCols.map(({header}) => (
						<th key = {header}>
							{header}
						</th>
					))}
				</tr>
			</thead>
			<tbody>
				{trainers
					.sort(orderByName)
					.map(t => (
						<tr key = {t.id}>
							{trainerCols.map((col, idx) => (
								<td key = {idx}>
									{col.extract(t)}
								</td>
							))}
						</tr>))
				}
			</tbody>
		</Table>
	);


	// license overview
	const licenseTable = (
		<Table>
			<thead>
			<tr>
				{licenseCols.map(({header}) => (
					<th key = {header}>
						{header}
					</th>
				))}
			</tr>
			</thead>
			<tbody>
				{licenses.map(license => (
					<tr key = {license.license}>
						{licenseCols.map((col, idx) => (
							<td key = {idx}>
								{col.extract(license, trainers)}
							</td>
						))}
					</tr>
				))}
			</tbody>
		</Table>
	);



	// render

	return (
		<Container>
			<Row className = {'mb-5'}>
				<Col>
					{trainerTable}
				</Col>
			</Row>
			<Row>
				<Col className = {'col-4'}>
					{licenseTable}
				</Col>
			</Row>
		</Container>
	);
};

export default Stats;

/*
Trainer columns
- email
- name / vorname
- lizenz
- datum der letzten dokument-erstellung
- # klienten
- # dokumente
+ letzter login
 */
const trainerCols = [
	{
		header: 'Benutzer',
		extract: t => t.emailAddress,
	},
	{
		header: 'Name',
		extract: t => `${t.surname}, ${t.name}`,
	},
	{
		header: 'Lizenz',
		extract: t => t.license.displayName,
	},
	{
		header: '# Klienten',
		extract: t => t.clients.length,
	},
	{
		header: '# Dokumente',
		extract: t => (t.clients || [])
			.map(client => analysisFields
				.map(aType => (client[aType] || []))
				.flat())
			.flat()
			.length,
	},
	{
		header: 'Letzter Login',
		extract: t => t.lastLogin ? dateToDE(t.lastLogin) : '-',
	},
	{
		header: 'Letzte Analyse',
		extract: t => {
			const dates = (t.clients || [])
				.map(client => analysisFields
					.map(aType => (client[aType] || []))
					.flat())
				.flat()
				.map(a => a.creationDate)
				.sort((d1, d2) => d1 > d2 ? -1 : 1);

			return dates[0] ? dateToDE(dates[0]) : '-';
		},
	},
];

/*
License columns
- # trainer je lizenz
- # klienten insgesamt
 */
const licenseCols = [
	{
		header: 'Lizenz',
		extract: l => l.displayName,
	},
	{
		header: '#',
		extract: (license, trainers) => trainers
			.filter(t => t.license.license === license.license)
			.length,
	},
]
